import HttpFactory from '../factory'

class InvoicesModule extends HttpFactory {
  RESOURCE = `/invoices`
  async get() {
    return await this.call(`get`, `${this.RESOURCE}/`)
  }

  async export(settings) {
    return await this.call(`put`, `${this.RESOURCE}/export/`, settings)
  }

  async addCredits(amount, reference, addressUUID) {
    return await this.call(`post`, `${this.RESOURCE}/credits/create`, { amount, reference, address_uuid: addressUUID })
  }

  // async pdf(id) {
  //   return await this.call(`get`, `${this.RESOURCE}/${id}/`)
  // }
}

export default InvoicesModule
